import { useEffect, useState } from 'react';
import { Refresh } from '@mui/icons-material';
import Loading from '../../../common/loading';
import Table from '../../../common/table';
import { Urls } from '../../../../config/urls';
import l from '../../../../lang';
import './styles.scss';
import MessageError from '../../../common/message-error';
import TopDashboardSection from '../../../common/top-dashboard-section';
import { usePaymentLink } from '../../../../store/payment-link';
import ChipStatus from '../../../common/chip-status';
import CopyToClipboard from 'react-copy-to-clipboard';
import IconButton from '../../../common/icon-button';
import { ReactComponent as CopyIcon } from '../../../../assets/icons/copy.svg';
import Moment from 'react-moment';
import Card from '../../../common/card';
import CardTitle from '../../../common/card-title';
import CardDescription from '../../../common/card-description';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import { Routes } from '../../../../config/routes';
import { useHistory } from 'react-router-dom';
import { ReactComponent as PlusIcon } from '../../../../assets/icons/plus.svg';
import { PaymentStatus } from '../../../../constants';
import { Tooltip } from '../../../common/tooltip';
import { segmentPaymentLinkLinkListBtnCreatePaymentLink } from '../../../../utils/analytics';

const CreatedPaymentLinks = () => {
  const history = useHistory();

  const [wasCopied, setWasCopied] = useState(false);

  const { createdPaymentLinks, getCreatedPaymentLinks } = usePaymentLink();
  const { loading, error, allPaymentLinks } = createdPaymentLinks;

  useEffect(() => {
    getCreatedPaymentLinks();
  }, []);

  const dataExist = allPaymentLinks && allPaymentLinks?.data?.length > 0;

  const onCreatePaymentLinkHandler = () => {
    segmentPaymentLinkLinkListBtnCreatePaymentLink();
    history.push(Routes.CREATE_PAYMENT_LINK);
  }

  return (
    <div className="created_payment_links">
      <TopDashboardSection title={l('menu.item.PAYMENT_LINK')} />
      <Card>
        <CardTitle>{l('createdPaymentLink.headline')}</CardTitle>
        <CardDescription>{l('createdPaymentLink.subheadline')}</CardDescription>
        <div className="created_payment_links__create_btn">
          <ButtonCustom
            text={l('createdPaymentLink.redirectBtn')}
            onClick={onCreatePaymentLinkHandler}
            startIcon={<PlusIcon />}
            component={undefined}
            innerComponent={undefined}
            fullWidth
          />
        </div>
        <div className="created_payment_links__content">
          {loading && (
            <div className="created_payment_links__loading">
              <Loading />
            </div>
          )}
          {error && (
            <div className="created_payment_links__error">
              <MessageError iconClose={<Refresh />} onClose={() => getCreatedPaymentLinks()} />
            </div>
          )}
          {!loading && !error && (
            <div>
              <Table
                dense
                headers={[
                  <span className="created_payment_links__left">{l('createdPaymentLink.creationDate')}</span>,
                  <span className="created_payment_links__left">{l('createdPaymentLink.link')}</span>,
                  <span className="created_payment_links__left">{l('createdPaymentLink.country')}</span>,
                  <span className="created_payment_links__left">{l('createdPaymentLink.expirationDate')}</span>,
                  <span className="created_payment_links__left">{l('createdPaymentLink.description')}</span>,
                  <span className="created_payment_links__right">{l('createdPaymentLink.amount')}</span>,
                  <span>{l('createdPaymentLink.paymentStatus')}</span>,
                ]}
                emptyBody={
                  <div className="created_payment_links__no_data">
                    <div className="created_payment_links__no_data__title">{l('createdPaymentLink.noPaymentLink')}</div>
                    <div>{l('createdPaymentLink.noPaymentLinkDesc')}</div>
                  </div>
                }
                body={
                  (dataExist &&
                    allPaymentLinks?.data?.map(pl => [
                      <span className="created_payment_links__left">
                        {pl.creationDate ? <Moment format="DD/MM/YYYY">{pl.creationDate}</Moment> : '-'}
                      </span>,
                      <div className="created_payment_links__left created_payment_links__link">
                        <div className="created_payment_links__link__copy">
                          {pl.paymentStatus === PaymentStatus.PENDING && (
                            <CopyToClipboard text={pl.paymentLink} onCopy={() => setWasCopied(true)}>
                              <Tooltip
                                onMouseEnter={() => setWasCopied(false)}
                                classes={{
                                  tooltip: `created_payment_links__tooltip ${wasCopied && ' copied'}`,
                                  arrow: `created_payment_links__tooltip__arrow ${wasCopied && ' copied'}`,
                                }}
                                title={l(wasCopied ? 'createdPaymentLink.copiedLink' : 'createdPaymentLink.copyLink')}
                              >
                                <div>
                                  <IconButton>
                                    <CopyIcon />
                                  </IconButton>
                                </div>
                              </Tooltip>
                            </CopyToClipboard>
                          )}
                        </div>
                        <div className="created_payment_links__link__wrapper">
                          <div className="created_payment_links__link__text">
                            <span>{pl.paymentLink || '-'}</span>
                          </div>
                        </div>
                      </div>,
                      <span className="created_payment_links__left">
                        {pl.country ? (
                          <span className="created_payment_links__country">
                            <img
                              alt=""
                              className="created_payment_links__country_flag"
                              src={`${Urls.flags.replace(':code', pl.country)}`}
                            />
                            <span>&nbsp;{pl.country}</span>
                          </span>
                        ) : (
                          '-'
                        )}
                      </span>,
                      <span className="created_payment_links__left">
                        {pl.expirationDate ? <Moment format="DD/MM/YYYY">{pl.expirationDate}</Moment> : '-'}
                      </span>,
                      <span className="created_payment_links__left">{pl.description || '-'}</span>,
                      <span className="created_payment_links__right">
                        {pl.currency && pl.amount ? pl.currency + ' ' + pl.amount : '-'}
                      </span>,
                      <span>
                        {(pl.paymentStatus && (
                          <ChipStatus
                            fullWidth
                            status={pl.paymentStatus}
                            text={l(`transactions.status.${pl.paymentStatus}`)}
                          />
                        )) ||
                          '-'}
                      </span>,
                    ])) ||
                  null
                }
                rowsPerPageOptions={[10, 25, 50]}
                rowsLength={allPaymentLinks?.totalElements}
                rowsPerPage={allPaymentLinks?.size}
                page={allPaymentLinks?.page}
                handleChangePage={(event, newPage) => getCreatedPaymentLinks(newPage, allPaymentLinks?.size)}
                handleChangeRowsPerPage={event => getCreatedPaymentLinks(0, event.target.value)}
                maxHeight={undefined}
              />
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default CreatedPaymentLinks;
